import React from 'react';

interface Properties {
  width?: any;
  height?: any;
}

const SearchIcon = ({ width, height }: Properties) => {
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox='0 0 30 23'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <mask id='mask0_184_3799' maskUnits='userSpaceOnUse' x='0' y='0' width='30' height='23'>
          <rect x='0.958008' y='0.0610352' width='28.649' height='22.9272' fill='#D9D9D9' />
        </mask>
        <g mask='url(#mask0_184_3799)'>
          <path
            d='M24.2875 19.7182L16.7901 13.7182C16.1933 14.1125 15.5069 14.4212 14.731 14.6441C13.9551 14.867 13.1524 14.9784 12.3229 14.9784C10.2827 14.9784 8.55593 14.4131 7.14274 13.2824C5.72955 12.1518 5.02295 10.7703 5.02295 9.13794C5.02295 7.50559 5.72937 6.12358 7.1422 4.99191C8.55504 3.86026 10.2813 3.29443 12.3211 3.29443C14.3608 3.29443 16.0877 3.85991 17.5018 4.99086C18.9158 6.12181 19.6229 7.50367 19.6229 9.13644C19.6229 9.81862 19.4798 10.4702 19.1936 11.0911C18.9074 11.7121 18.5256 12.2522 18.0481 12.7115L25.5455 18.7115L24.2875 19.7182ZM12.3229 13.5455C13.861 13.5455 15.1637 13.1184 16.2312 12.2641C17.2986 11.4099 17.8323 10.3673 17.8323 9.13644C17.8323 7.90556 17.2986 6.863 16.2312 6.00873C15.1637 5.15447 13.861 4.72734 12.3229 4.72734C10.7848 4.72734 9.48209 5.15447 8.41464 6.00873C7.3472 6.863 6.81348 7.90556 6.81348 9.13644C6.81348 10.3673 7.3472 11.4099 8.41464 12.2641C9.48209 13.1184 10.7848 13.5455 12.3229 13.5455ZM9.47638 9.85289V8.41999H15.1695V9.85289H9.47638Z'
            fill='#D9D9D9'
          />
        </g>
      </svg>
    </>
  );
};

export default SearchIcon;
